import { CountriesPage } from "./CountriesPage";

export const MainPage = () => {

    return (
        <div>
            <CountriesPage />
        </div>
    );
}